import { render, staticRenderFns } from "./sonPower.vue?vue&type=template&id=37d7a57e&scoped=true&"
import script from "./sonPower.vue?vue&type=script&lang=js&"
export * from "./sonPower.vue?vue&type=script&lang=js&"
import style0 from "./sonPower.vue?vue&type=style&index=0&id=37d7a57e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7a57e",
  null
  
)

export default component.exports